import React from 'react';
import classnames from 'classnames';
import { Col, LabelText, Row } from '@policygenius/mortar';
import { POLICYGENIUS_EMAIL } from '~/containers/App/constants';
import Icon from './icon';
import Link from './link';
import { FOOTER_LINKS, BBB_IMG_ALT, BBB_IMG_URL, PG_EMAIL_ALT } from './constants';

import styles from './navigator_footer.module.scss';

const NavigatorFooter = () => (
  <footer className={styles.footer}>
    <Row className={styles.grid} nested>
      <Col span={{ small: 4, medium: 4 }} className={styles.leftCol}>
        <Link
          href={`mailto:${POLICYGENIUS_EMAIL}`}
          size="large"
          variant="secondary"
          className={classnames(styles.contactCta, styles.emailLink)}
        >
          <Icon alt={PG_EMAIL_ALT} icon="email" height="24px" width="24px" />
          <LabelText color="inherit" size="large" className={styles.emailText}>
            {POLICYGENIUS_EMAIL}
          </LabelText>
        </Link>
      </Col>
      <Col span={{ small: 4, medium: 4 }} push={{ medium: 8 }}>
        <img alt={BBB_IMG_ALT} src={BBB_IMG_URL} width={'84px'} />
        <ul className={styles.links}>
          {FOOTER_LINKS.map((link) => (
            <li key={link.href}>
              <Link href={link.href} variant="secondary">
                {link.text}
              </Link>
            </li>
          ))}
        </ul>
      </Col>
    </Row>
  </footer>
);

export default NavigatorFooter;
